import * as React from 'react';
import { connect } from 'react-redux';

import { ILocation } from '../../../../api/locations';
import { IAppState, Dispatch } from '../../../../common/state';
import { changeDeveloperType } from '../../../state/advanced/developer';
import { Row } from '../markup';
import { ButtonRadioGroupParamView } from './abstract_params/views/button_radio_group_param';
import Promo from './promo';

interface IDeveloperProps {
  fromDeveloper: boolean | undefined;
  onChangedDeveloperType(value: boolean | undefined): void;

  currentLocation: ILocation | 'moscow_mo' | 'spb_lo';
}

const revertValue = (value: boolean | undefined) => (value === undefined ? undefined : !value);

const developer: React.StatelessComponent<IDeveloperProps> = props => {
  return (
    <Row title="Тип объявления">
      <ButtonRadioGroupParamView
        value={revertValue(props.fromDeveloper)}
        falseValue="От застройщиков"
        trueValue="От агентов и частных лиц"
        onValueChange={value => props.onChangedDeveloperType(revertValue(value))}
      />

      <Promo />
    </Row>
  );
};

// tslint:disable-next-line:no-default-export
export default connect<
  { fromDeveloper: boolean | undefined },
  { onChangedDeveloperType(value: boolean): void },
  { currentLocation: ILocation | 'moscow_mo' | 'spb_lo' }
>(
  (state: IAppState) => ({
    fromDeveloper: state.filters.jsonQuery.from_developer && state.filters.jsonQuery.from_developer.value,
  }),
  (dispatch: Dispatch) => ({
    onChangedDeveloperType: (value: boolean): void => {
      dispatch(changeDeveloperType(value));
    },
  }),
)(developer);
